// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2Syrz","fileDisabled":"File_fileDisabled__2AsU2"};